declare global {
  interface Window {
    AwsWafIntegration?: {
      fetch: typeof fetch;
    };
    AwsWafCaptcha?: {
      renderCaptcha: (
        container: HTMLElement,
        config: {
          apiKey: string;
          onSuccess: (token: string) => void;
          onError: (error: Error) => void;
          onLoad?: () => void;
          onPuzzleTimeout?: () => void;
          onPuzzleCorrect?: () => void;
          onPuzzleIncorrect?: () => void;
          dynamicWidth?: boolean;
          skipTitle?: boolean;
          defaultLocale?: string;
        }
      ) => void;
    };
  }
}

export function getWafIntegration() {
  if (typeof window === 'undefined') {
    return undefined;
  }

  return window.AwsWafIntegration;
}
